/*
 * Voorkomt dat een bezoeker hetzelfde contactformulier twee keer verstuurt.
 *
 * Aanleiding (23-09-2026): een klant klikte binnen een seconde drie keer op 'versturen'. Shopify
 * maakt per klik een aparte notificatiemail met een eigen bericht-id, waardoor er in Odoo drie
 * identieke tickets ontstonden. Odoo sluit dubbelen inmiddels automatisch, maar dat is het
 * vangnet - hier wordt het probleem bij de bron weggenomen.
 *
 * Werking: bij de eerste verzending krijgt het formulier een merkteken. Elke volgende poging wordt
 * tegengehouden. De knop wordt pas ná het begin van de verzending uitgezet: zet je hem meteen uit,
 * dan sturen sommige browsers de waarde van de knop niet mee.
 */
(function () {
  function isContactformulier(form) {
    var actie = form.getAttribute('action') || '';
    return actie.indexOf('/contact') !== -1;
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM' || !isContactformulier(form)) return;

      if (form.dataset.verstuurd === '1') {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      form.dataset.verstuurd = '1';

      var knop = form.querySelector('[type="submit"]');
      if (knop) {
        knop.setAttribute('aria-busy', 'true');
        setTimeout(function () {
          knop.disabled = true;
        }, 0);
      }
    },
    true // capture: vóór eventuele andere afhandelaars
  );
})();
